import adminHttp from "@/api/adminHttp";

const END_POINT = '/api/v1/admin/rating/tournament';

export default {
    index: (params) => adminHttp.get(END_POINT + `/${params.tournId}`, {params: params}),
    show: (params) => adminHttp.get(END_POINT + `/team/${params.tournId}` + `/${params.teamId}`),
}